module.exports = __webpack_public_path__ + "static/media/info.edafc0a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/info.svg
// module id = 492
// module chunks = 0